import { BreakoutType } from '@/types'

export const BREAKOUT_TYPE_TO_DISPLAY_NAME: Record<BreakoutType, string> = {
  [BreakoutType.UNDO]: 'Undo',
  [BreakoutType.BY_SIZE]: 'By Size',
  [BreakoutType.BY_POLL]: 'By Poll',
  [BreakoutType.BY_LAST_POLL]: 'By Last Poll',
  [BreakoutType.BY_NUMBER_OF_TEAMS]: 'By Number Of Teams',
}
